export { default } from './tag';
